module.exports = __webpack_public_path__ + "media/images/static/line/advisor_mobile-d00b32aa5e4d043ceeb69f018da7fe1d.png";